export default __webpack_public_path__ + "static/assets/med_pill_round_out_L0_solid_l_01_f_mask.2364fd15.png";